<template>
  <div class="cvc-view">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CvcView"
};
</script>

<style lang="scss" scoped>
  .cvc-view {
    min-height: calc(100vh - 40px);
  }
</style>
